export default "__VITE_ASSET__B8PAf05m__"